import React from 'react';
import { observer } from 'mobx-react';
import TemplateManageStore from '../../stores/list/TemplateManageStore';
import { WeaFormItem, WeaDialog, WeaLocaleProvider } from 'ecCom';
import { WeaSwitch } from 'comsMobx';
import { Button } from 'antd';
const getLabel = WeaLocaleProvider.getLabel;

export interface EidtTemplateProps {
    templateManageStore: TemplateManageStore
}
@observer
export default class EidtTemplate extends React.Component<EidtTemplateProps, any> {
    render() {
        const { templateManageStore } = this.props;
        let formParams = templateManageStore.form.getFormParams();
        return (
            <div >
                {
                    templateManageStore.fields.map((d,idn) => {
                        return (<div className="wea-search-group" style={d.hide ? { display: 'none' } : {}}>
                            <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@ev02ho@${idn}`}
                                label={d.label}
                                labelCol={{ span: d.labelcol }}
                                wrapperCol={{ span: d.fieldcol }}
                                error={templateManageStore.form.getError(d)}
                                tipPosition="bottom"
                            >
                                <WeaSwitch ecId={`${this && this.props && this.props.ecId || ''}_WeaSwitch@46ccfh@${idn}`} fieldConfig={d} form={templateManageStore.form} formParams={formParams}  />
                            </WeaFormItem></div>
                        )
                    })
                }
            </div >
        )
    }
}

@observer
export class EidtTemplateDialog extends React.Component<EidtTemplateProps, any>{
    render() {
        const { templateManageStore } = this.props; 
        const { iconInfo } = templateManageStore;
        const buttons = [<Button ecId={`${this && this.props && this.props.ecId || ''}_Button@v9w1of@visible`} onClick={() => { templateManageStore.visible = false }}>{getLabel(309, "关闭")}</Button>,
        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@y9sap4@save`} type="primary" loading={templateManageStore.loading} onClick={() => { templateManageStore.save() }}>{getLabel(86, '保存')}</Button>]
        return (
            <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@sgmxx7`}
                className='wea-auth-modal cube-dialog'
                buttons={buttons}
                title={templateManageStore.form.getFormParams().id ? getLabel(532924, '编辑模板') : getLabel(532925, '新建模板')}
                iconBgcolor={iconInfo.iconBg || "#96358a"}
                icon={iconInfo.icon || 'icon-coms-ModelingEngine'}
                iconFontColor={iconInfo.iconColor || "#fff"}
                visible={templateManageStore.visible}
                style={{ width: 520, height: 260 }}
                hasScroll={true}
                onCancel={() => { templateManageStore.visible = false }}
            >
                <EidtTemplate ecId={`${this && this.props && this.props.ecId || ''}_EidtTemplate@09kp8n`} templateManageStore={templateManageStore} />
            </WeaDialog >
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/pages/templateManage/EidtTemplate.tsx